import React from 'react';
import PropTypes from 'prop-types';

export const singleInputPropTypes = {
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func,
    required: PropTypes.bool,
    autoComplete: PropTypes.bool,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    note: PropTypes.string
};